
export class LoginRequest
{
    emailOrUsername: string;
    password: string;
}